<template>
    <div class="flex flex-col justify-between gap-5 py-7 px-5 bg-white border border-valence-grey-300 rounded-lgr min-w-60 max-w-60 grow">
        <SkeletonLoader v-if="isLoading" class="h-[100px] w-full rounded-lgr" />
        <div v-else class="body-small">{{ formattedQuote }}</div>
    </div>
</template>

<script setup lang="ts">
import SkeletonLoader from "~vue/components/SkeletonLoader.vue";
import { computed } from "vue";

const { quote = "", isLoading = false } = defineProps<{
    quote?: string;
    isLoading?: boolean;
}>();

const formattedQuote = computed(() => {
    if (!quote || quote.startsWith('"')) {
        return quote;
    }
    return `"${quote}"`;
});
</script>
